module.exports = __webpack_public_path__ + "media/newstyle/images/stars_1-red-fcd3bc72d470e1831b3d4a13f236e854.svg";